Object.defineProperty(exports, "__esModule", { value: true });
var Sequence_1 = require("./Sequence");
var Minus = /** @class */ (function () {
    function Minus() {
    }
    /**
     * Removes the given `data` and returns a new sequence. Data can either be a single element, an array of elements
     * or a sequence of elements.
     *
     * @param {Sequence<T> | Array<T> | T} data
     * @returns {Sequence<T>}
     */
    Minus.prototype.minus = function (data) {
        if (Sequence_1.isSequence(data)) {
            var array_1 = data.toArray();
            return this.filter(function (it) { return array_1.indexOf(it) < 0; });
        }
        else if (data instanceof Array) {
            return this.filter(function (it) { return data.indexOf(it) < 0; });
        }
        else {
            return this.filter(function (it) { return it !== data; });
        }
    };
    return Minus;
}());
exports.Minus = Minus;
//# sourceMappingURL=minus.js.map